import { useTestCreationContext } from "../../../../../../context/TestCreationContext";
import { ExerciseDirections } from "../../../../../../enums/directions";
import { Exercises, ExerciseTypes } from "../../../../../../enums/exercises";
import { sanitizeText } from "../../../../../../helpers/TestCreation";
import { getMinWordsForExerciseType } from "../../../../../../helpers/ExerciseTypesHelper";
import { Box, Item, RemoveIconWrapper, RemoveIcon, Word } from "./StyledComponents";

interface ExerciseWordBoxProps {
    onRemoveWord: (wordId?: string) => void;
}

const ExerciseWordBox: React.FC<ExerciseWordBoxProps> = (props) => {
    const { currentExerciseModel } = useTestCreationContext();
    const minWords = getMinWordsForExerciseType(currentExerciseModel.questionMode);

    // A CREATE_TEXT exercise reverts to FREE_TEXT when its last word is removed, so
    // removal stays enabled there even at the minimum-words threshold.
    const isCreateText = currentExerciseModel.questionMode === ExerciseTypes.get(Exercises.CREATE_TEXT);
    const isRemovalDisabled = !isCreateText && (currentExerciseModel.wordsInProgress?.length ?? 0) <= minWords;

    return (
        <Box>
            {currentExerciseModel.wordsInProgress?.map((word) => {
                if ("id" in word) {
                    const wordToShow =
                        currentExerciseModel.direction === ExerciseDirections.ANSWER_TO_QUESTION
                            ? word.answer
                            : word.question;

                    return (
                        <Item key={word.id}>
                            <Word>{sanitizeText(wordToShow || "")}</Word>
                            <RemoveIconWrapper
                                data-testid={`exercise-word-remove-${word.id}`}
                                onClick={() => props.onRemoveWord(word.id)}
                                className={isRemovalDisabled ? "disabled" : ""}
                            >
                                <RemoveIcon name={"close"} />
                            </RemoveIconWrapper>
                        </Item>
                    );
                }
                return null;
            })}
        </Box>
    );
};

export default ExerciseWordBox;
